import React from 'react';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import FAQ from './components/FAQ';
import Expertise from './components/Expertise';
import MeetCoach from './components/MeetCoach';
import TrialCTA from './components/TrialCTA';
import MethodSection from './components/MethodSection';
import Hero from './components/Hero';

class App extends React.Component {
  render() {
    return (
      <div className="font-sans">
        {/* <Hero5 /> */}
        <Hero />
        {/* <Hero3 />
        <Hero2 /> */}
        {/* <HowItWorks2 /> */}
        <HowItWorks />
        <Testimonials />
        <Features />
        {/* <Testimonials3 /> */}
        {/* <ClientJourney /> */}
        <Expertise />
        <MeetCoach />
        <CTA />
        <TrialCTA />
        <MethodSection />
        <FAQ />
        <Footer />
      </div>
    );
  }
}

export default App;